import { useTranslation } from "react-i18next";
import { SectionTitle } from "../../PresentationalComponents/SectionTitle";
import styles from "./AboutMe.module.css";
import { Cpu, MapPinned, GraduationCap } from "lucide-react";

const aboutMe = {
  fa: {
    description: [
      "مسیر من در فناوری با هوش مصنوعی و بینایی ماشین شروع شد. روی خودروهای خودران کار کردم و در پروژه‌ای پژوهشی مشارکت داشتم که حاصل آن به انتشار یک مقاله علمی منجر شد. آنجا بود که به حل مسائل پیچیده و تبدیل ایده‌ها به سیستم‌های واقعی علاقه‌مند شدم.",
      "بعد از دوران سربازی، علاقه‌ام به سمت توسعه وب رفت. از فرانت‌اند و React شروع کردم و با ترکیب برنامه‌نویسی و علاقه‌ام به طراحی، به‌تدریج مسیرم را به سمت توسعه فول‌استک ادامه دادم.",
      "در کنار مسیر حرفه‌ای، دوباره به شکل جدی به علوم کامپیوتر برگشتم و در کنکور سراسری کارشناسی ارشد کامپیوتر، در جمع ۳۰۰ نفر برتر کشور قرار گرفتم. امروز تلاش می‌کنم تجربه‌ام در هوش مصنوعی، حل مسئله و توسعه وب را برای ساخت تجربه‌های دیجیتال مدرن و کاربردی به کار بگیرم.",
    ],
  },
  en: {
    description: [
      "My journey in technology began with Artificial Intelligence and computer vision. I worked on autonomous driving and contributed to a research project that resulted in a published paper. It was where I learned to enjoy solving complex problems and turning ideas into working systems.",
      "After military service, I discovered a new passion in web development. I started with front-end development and React, combining programming with my interest in design, and gradually expanded my skills toward becoming a full-stack developer.",
      "Alongside my professional journey, I returned to Computer Science and ranked among the top 300 candidates nationwide in Iran’s Master's entrance examination in Computer Engineering. Today, I bring together my background in AI, problem-solving, and web development to build modern, practical, and engaging digital experiences.",
    ],
  },
};
export function AboutMe({ t }) {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <section className={styles.sectionContainer} id="AboutMe">
      <div className={styles.descContainer}>
        <div className={styles.setcionTitleBox}>
          <SectionTitle
            text={t("AboutMe.section-name")}
            num={t("AboutMe.section-num")}
          />
        </div>

        <strong>{t("AboutMe.header")}</strong>
        <br />
        {aboutMe[lang].description.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
      <div className={styles.verticalLine}></div>
      <div className={styles.featureContainer}>
        <div className={styles.feature}>
          <MapPinned className={styles.svg} />
          <div className={styles.featureTextBox}>
            <label>{t("AboutMe.feature-one.title")}</label>
            <p>{t("AboutMe.feature-one.description")}</p>
          </div>
        </div>
        <div className={styles.feature}>
          <Cpu className={styles.svg} />
          <div className={styles.featureTextBox}>
            <label>{t("AboutMe.feature-two.title")}</label>
            <p>{t("AboutMe.feature-two.description")}</p>
          </div>
        </div>
        <div className={styles.feature}>
          <GraduationCap className={styles.svg} />
          <div className={styles.featureTextBox}>
            <label>{t("AboutMe.feature-three.title")}</label>
            <p>{t("AboutMe.feature-three.description")}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
